export const isMobileDevice = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    );
};

/**
 * Visibility-control mechanism for menu options on small devices.
 * On a mobile device only items explicitly flagged `mobileSupported` survive;
 * on desktop every item passes through unchanged. Both the admin menu
 * (GeneralMenu) and the chat menu (ChatList) filter their items through this so
 * the options on offer stay in sync with the routes the mobile router serves
 * (everything else redirects to /new-chat).
 */
export const filterMobileSupported = <T extends { mobileSupported?: boolean }>(items: T[]): T[] =>
    isMobileDevice() ? items.filter(item => item.mobileSupported) : items;

export const isIOS = () => {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

export const isChromium = () => {
    return !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
};
